<template>
  <span>{{ label }}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import recognition from '@/auth/recognition';
import { User } from '@/type';

export default defineComponent({
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  computed: {
    label(): string {
      if (recognition.getUserId() === this.user.id) {
        return 'you';
      }
      return `${this.user.firstName} ${this.user.lastName}`;
    },
  },
});
</script>
